import React, { useState } from "react";
import "./style.scss";

const Number = (props) => {
  const [isSelected, setSelected] = useState(false);
  const [scaled, setScaled] = useState(false);

  const animateDelayTime = () => {
    let i;
    let numbers = props.selectedNums.filter((number) => {
      return number > 0;
    });
    for (i = 0; i < numbers.length; i++) {
      if (numbers[i] && numbers[i] === props.number) {
        return i * 1.5 + 1 + "s";
      }
    }
  };

  const isSelectedNum = () => {
    let i;
    for (i = 0; i < props.selectedNums.length; i++) {
      if (props.selectedNums[i] === props.number) {
        return true;
      }
    }
    return false;
  };

  const backgroundColor = () => {
    let i;
    let sum = 0;

    if (props.showResult && isSelectedNum()) {
      for (i = 0; i < props.selectedNums.length; i++) {
        if (props.selectedNums[i]) sum += props.selectedNums[i];
      }
      if (sum < props.average) return "red";
      else return "transparent";
    } else if (props.isSum && isSelectedNum()) {
      return "transparent";
    }
  };

  const border = () => {
    let i;
    let sum = 0;

    if (props.showResult && isSelectedNum()) {
      for (i = 0; i < props.selectedNums.length; i++) {
        if (props.selectedNums[i]) sum += props.selectedNums[i];
      }
      if (sum < props.average) return "";
      else return "solid 1px #D8A93E";
    } else if (props.isSum && isSelectedNum()) {
      return "solid 1px #D8A93E";
    } else {
      return "";
    }
  };

  const color = () => {
    let i;
    let sum = 0;
    if (props.showResult && isSelectedNum()) {
      for (i = 0; i < props.selectedNums.length; i++) {
        if (props.selectedNums[i]) sum += props.selectedNums[i];
      }
      if (sum < props.average) return "white";
      else return "#FCB619";
    } else if (props.isSum && isSelectedNum()) {
      return "#FCB619";
    } else {
      return "";
    }
  };

  return (
    <div>
      {props.animate ? (
        <div
          className={isSelectedNum() ? "animate" : "sum"}
          style={{ animationDelay: animateDelayTime() }}
        >
          {props.number}
        </div>
      ) : (
        <div
          className={props.isSum ? "sum" : !isSelected ? "number" : "hover"}
          style={{
            transform: scaled ? "scale(2)" : "scale(1)",
            backgroundColor: backgroundColor(),
            border: border(),
            color: color(),
          }}
          onClick={() => {
            setScaled(true);
            setTimeout(() => {
              setScaled(false);
            }, 100);
            if (!props.isSum) {
              if (isSelected) {
                setSelected(false);
                props.decreaseCount();
                props.handleClick(props.info);
              } else if (props.selectedCount < 7) {
                if (props.selectedCount === 6) {
                  setSelected(true);
                } else {
                  setSelected(true);
                }
                props.increaseCount();
                props.handleClick(props.info);
              }
            }
          }}
        >
          {props.number}
        </div>
      )}
    </div>
  );
};

export default Number;
